import React from "react";
import styles from "./AuthLinks.module.scss";

interface AuthLinksProps {
  text: string;
  linkText: string;
  onLinkClick: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}

export const AuthLinks: React.FC<AuthLinksProps> = ({ text, linkText, onLinkClick }) => {
  return (
    <div className={styles.links}>
      <span>{text}</span>
      <a href="#" className={styles.link} onClick={onLinkClick}>
        {linkText}
      </a>
    </div>
  );
};

